<div class="page">
  <div class="wrapper">

    <div class="info-title">
      <h1>Supplier Center</h1>
    </div>

    <div class="flex-row search-section">
      <input  placeholder="Search Supplier ID, Supplier Name, or Email.." type="text" class="input input-lg search-bar" [(ngModel)]="searchFilter" (input)="filterSupplierList()">
    </div>


    <div class="content-section">

      <div class="content-header">
        <ul class="flex-row">
          <li class="flex-2 content-cell">Supplier ID</li>
          <li class="flex-2 content-cell">Flanders Vendor Number</li>
          <li class="flex-2 content-cell">Swords Vendor Number</li>
          <li class="flex-2 content-cell">Llanberis Vendor Number</li>
          <li class="flex-2 content-cell">Los Angeles Vendor Number</li>
          <li class="flex-2 content-cell">Supplier Name</li>
          <li class="flex-2 content-cell">Email</li>
          <li class="flex-1 content-cell">Delete</li>
        </ul>
      </div>

      @if ((listLoaded)) {
        <div>
          @for (supplier of supplierFilteredList | paginate: { itemsPerPage: 10, currentPage: page }; track supplier) {
            <div class="content-main">
              <div class="content-item">
                <ul class="item-main flex-row">
                  <li class="flex-2 content-cell">{{supplier.supplierID}}</li>
                  <li class="flex-2 content-cell">{{supplier.flandersVN}}</li>
                  <li class="flex-2 content-cell">{{supplier.swordsVN}}</li>
                  <li class="flex-2 content-cell">{{supplier.llanberisVN}}</li>
                  <li class="flex-2 content-cell">{{supplier.lasAngelesVN}}</li>
                  <li class="flex-2 content-cell">{{supplier.companyName}}</li>
                  <li class="flex-2 content-cell">{{supplier.email}}</li>
                  <li class="flex-1 content-cell btn-delete" (click)="deleteSupplier(supplier)">DELETE</li>
                </ul>
              </div>
            </div>
          }
        </div>
      } @else {
        <div class="loading-container">
          <div class="flex-row spinner">
            <mat-progress-spinner mode="indeterminate" diameter="150"></mat-progress-spinner>
          </div>
          <div class="flex-row message">
            <h2>Loading Suppliers...</h2>
          </div>
        </div>
      }


      <pagination-controls (pageChange)="page = $event"></pagination-controls>

    </div>

    <div class="button button-secondary" (click)="addSupplier()"> Add New Supplier </div>

  </div>
</div>
